
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpClient, HttpXhrBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InProgressInterceptor } from './shared/components/loading-spinner/in-progress.interceptor';
import { provideTranslateService, TranslateLoader, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ApimInterceptor } from './shared/apim.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation(), withRouterConfig({ onSameUrlNavigation: 'reload' })),
    TranslateStore,
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      defaultLanguage: 'en',
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoader,
        deps: [HttpClient],
      },
    }),

    { provide: HTTP_INTERCEPTORS,useClass: InProgressInterceptor,multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: ApimInterceptor, multi: true },
    providePrimeNG({
      theme: {
        preset: Lara, options: {
          darkModeSelector: '.p-dark',
          cssLayer: {
            name: 'primeng',
            order: 'primeng'
          }
        }
      },
    }),
    provideAnimationsAsync(),
  ],
};

export function translateLoader() {
  var http = new HttpClient(
    new HttpXhrBackend({ build: () => new XMLHttpRequest() })
  );
  return new TranslateHttpLoader(http, 'i18n/hms/', '.json');
}